export const QUERY = `
query jiraProject($cloudId: ID!, $projectIdOrKey: String!, $shouldFetchProjectAccess: Boolean! = false) {
  jira_projectByIdOrKey(cloudId: $cloudId, idOrKey: $projectIdOrKey) {
    id
    projectId
    key
    uuid
    name
    avatar {
      medium
    }
    projectType
    projectStyle
    status
    created
    isAIEnabled
    canAdministerProject: action(type:EDIT_PROJECT_CONFIG) {
      canPerform
    }
    accessLevel @optIn(to: "JiraProjectAccessLevel") @include(if: $shouldFetchProjectAccess)
  }
}`;
